export let props = ['title', 'input', 'dialogVisible', 'rules', 'labelWidth', 'loading', 'width', 'top', 'footer']
